import { render, staticRenderFns } from "./ChargeList.vue?vue&type=template&id=88b8444a&"
import script from "./ChargeList.vue?vue&type=script&lang=js&"
export * from "./ChargeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports